import { getApi } from "./api_instance";

export const getDashboardDemands = async (dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: "/projects/api/dashboard/top-credits/demand",
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
